import { createFileRoute } from '@tanstack/react-router';

import { NotificationsView } from 'src/sections/notifications/notifications-view';

/**
 * The same inbox, reachable from the staff shell.
 *
 * `/dashboard/notifications` sits under `_authed`, which gates on a completed
 * organization and mounts a subscription provider — neither of which a NexMail
 * employee has (that is why `/w` exists at all). The bell appears in both
 * shells, so its "See all" needs a destination in both.
 */
export const Route = createFileRoute('/w/notifications')({
  component: NotificationsView,
});
